<template>
  <section style="width: 100%;">
    <app-container-loading
      :show="isLoading"
      :text="'Criando entregador...'"
    ></app-container-loading>
    <section class="create-companies__main-area">
      <div
        style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;"
      >
        <div style="display: flex; justify-content: space-between;">
          <div class="column">
            <div class="header">
              <router-link
                to="/master/deliverymen"
                exact
                tag="li"
                :title="'Entregadores Zepplin'"
                v-tippy="{
                  placement: 'right',
                  theme: 'light',
                  inertia: true,
                  arrow: true,
                  animation: 'perspective',
                }"
                class="box-add-icon"
              >
                <fa size="lg" icon="arrow-left" />
              </router-link>
            </div>
            <div>
              CRIAR ENTREGADORES ZEPPLIN
              <br />
              <small>
                *Para criar um entregador Zepplin, é necessário que esse
                entregador já possua um usuário no GestaON
              </small>
            </div>
            <div class="content-column">
              <div v-if="selectedUser.id" class="section-items">
                <div class="container__selected-user">
                  <div style="margin-right: 15px; max-width: 50px;">
                    <img
                      style="width: 50px; border-radius: 100%;"
                      :src="
                        this.selectedUser.avatarUrl
                          ? this.selectedUser.avatarUrl
                          : require('../../../assets/imgs/default-avatar.png')
                      "
                      :onerror="
                        `this.onerror=null;this.src='${require('../../../assets/imgs/default-avatar.png')}';`
                      "
                      alt=""
                    />
                  </div>
                  <div>
                    <div
                      v-for="(line, index) of getFormatedUser(
                        this.selectedUser
                      )"
                      :key="index"
                    >
                      {{ line }}
                    </div>
                    <div v-show="form.licensePlate">
                      Placa: {{ form.licensePlate.toUpperCase() }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-items">
                <div style="margin-right: 15px;">
                  Entregador:
                  <input
                    type="text"
                    class="input input-config"
                    placeholder="Digite o nome do entregador"
                    v-model="form.search"
                    @input="getUsers($event.target.value)"
                  />
                </div>
                <div style="width: 30%;">
                  Placa do Veículo
                  <input
                    type="text"
                    class="input input-config"
                    v-model="form.licensePlate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <app-perfect-scrollbar style="width: 100%; height: 40vh;">
            <div style="display: inline;">
              <div v-for="user of users" :key="user.id">
                <div class="search__box" @click="selectedUser = user">
                  <div
                    v-for="(line, index) of getFormatedUser(user)"
                    :key="index"
                  >
                    {{ line }}
                  </div>
                </div>
              </div>
            </div>
          </app-perfect-scrollbar>
        </div>
        <div>
          <div style="float:right; width: 200px;">
            <a
              href="javascript:void(0)"
              class="btn button-gradient"
              style="float: right"
              @click="submit()"
            >
              Salvar alterações
            </a>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import UsersAPI from "../../../api/users";

export default {
  props: ["user"],
  data() {
    return {
      search: "",
      form: {
        userName: "",
        userId: "",
        licensePlate: "",
        avatarUrl: null,
      },
      isLoading: false,
      searchTimeout: null,
      users: [],
      selectedUser: {
        id: null,
        name: null,
        avatarUrl: null,
        companyUsers: null,
      },
    };
  },
  computed: {
    ...mapState("auth", ["zepplinMasterToken"]),
    ...mapGetters("zepplin/company-categories", [
      "getCompanyCategoriesList",
      "getCompanyCategoryById",
    ]),
    ...mapGetters("zepplin/delivery-companies", [
      "getDeliveryCompaniesList",
      "getDeliveryCompanyById",
    ]),
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),
    validateForm() {
      const messages = [];
      if (!this.selectedUser || !this.selectedUser.id)
        messages.push("Você precisa selecionar um usuário do GestaON");
      return messages;
    },

    async submit() {
      const errorMessages = this.validateForm(this.form);
      errorMessages.forEach((errorMessage) => {
        this.showError(errorMessage);
      });
      if (errorMessages.length) return;

      this.isLoading = true;
      try {
        const form = {
          licensePlate: this.form.licensePlate,
          userId: this.selectedUser.id,
          name: this.selectedUser.name,
          imageUrl: this.selectedUser.avatarUrl,
        };

        await UsersAPI.createZepplinDeliveryman(form.userId, form, {
          masterToken: this.zepplinMasterToken,
        });
        this.showToast({
          type: "success",
          message: "Entregador Zepplin criado com sucesso.",
        });
      } catch (err) {
        console.error(err);
        this.showError("Não foi possível criar empresa.");
      }
      this.isLoading = false;
    },

    async getUsers(value) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        try {
          const users = await UsersAPI.getUsers({
            isIncludeCompanies: true,
            search: value,
            limit: 20,
            isNotZepplin: true,
          });
          this.users = users.data;
        } catch (err) {
          console.error(err);
        }
      }, 500);
    },

    getFormatedUser(user) {
      let arr = [];
      if (user.name && user.name.trim()) {
        arr.push(user.name);
        if (user.email && user.email.indexOf("@") !== -1) arr.push(user.email);
      }
      if (user.companyUsers && Array.isArray(user.companyUsers)) {
        const companies = [];
        user.companyUsers.forEach((companyUser) => {
          if (companyUser.company) companies.push(companyUser.company.name);
        });
        arr.push(companies.join(", "));
      }
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  margin-bottom: 10px;
}

.input-config {
  border-bottom: 1px solid #525662;
  width: 100%;
}

.column {
  width: 100%;
  font-weight: 600;
}

.content-column {
  margin-top: 20px;
  width: 100%;

  div {
    width: 100%;
  }
}

.field {
  display: flex;
  justify-content: space-between;
}

.section-items {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.create-companies__main-area {
  width: 100%;
  background-color: var(--bg-color--2);
  padding: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.search__box {
  padding: 20px 10px;
  border-bottom: 1px solid #525662;
  cursor: pointer;
}

.container__selected-user {
  padding: 20px;
  margin-bottom: 10px;
  border: 1px solid #525662;
  border-radius: 10px;
  width: auto !important;
  display: flex;
  align-items: center;
}

.header {
  margin-bottom: 20px;
}
</style>
